import {
  INTERACTION_TABS,
  INTERACTION_TAB_VALUES,
  type InteractionTab,
  SORT_ORDERS,
  SortOrderSchema,
} from '@cult/schemas';
import { z } from 'zod';

export const interactionFeedSearchSchema = z.object({
  tab: z.enum(INTERACTION_TAB_VALUES).catch(INTERACTION_TABS.RECEIVED),
  order: SortOrderSchema.catch(SORT_ORDERS.DESC),
  q: z.string().catch(''),
});

export type InteractionFeedSearch = z.infer<typeof interactionFeedSearchSchema>;

export const INTERACTION_TAB_ITEMS: { key: InteractionTab; label: string }[] = [
  { key: INTERACTION_TABS.RECEIVED, label: 'Received' },
  { key: INTERACTION_TABS.GIVEN, label: 'Given' },
];
